import { render, staticRenderFns } from "./View.vue?vue&type=template&id=987a920e&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=987a920e&lang=scss"
import style1 from "./View.vue?vue&type=style&index=1&id=987a920e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987a920e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('987a920e')) {
      api.createRecord('987a920e', component.options)
    } else {
      api.reload('987a920e', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=987a920e&scoped=true", function () {
      api.rerender('987a920e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/pcfooter/View.vue"
export default component.exports